import LoyaltyDetailSFC from "./LoyaltyDetail.vue";
export const LoyaltyDetail = LoyaltyDetailSFC;
